// extracted by mini-css-extract-plugin
module.exports = {"info":"product-info_info__O2r1r"};